import { useRef, useState } from "rehackt";
import { useIsomorphicLayoutEffect } from "./useIsomorphicLayoutEffect.js";
const useIsomorphicEffectOnce = (effect) => {
  const destroyFunc = useRef();
  const effectCalled = useRef(false);
  const renderAfterCalled = useRef(false);
  const [val, setVal] = useState(0);
  if (effectCalled.current) {
    renderAfterCalled.current = true;
  }
  useIsomorphicLayoutEffect(() => {
    if (!effectCalled.current) {
      destroyFunc.current = effect();
      effectCalled.current = true;
    }
    setVal((v) => v + 1);
    return () => {
      if (!renderAfterCalled.current) {
        return;
      }
      if (destroyFunc.current) {
        destroyFunc.current();
      }
    };
  }, []);
};
export {
  useIsomorphicEffectOnce
};
//# sourceMappingURL=useIsomorphicEffectOnce.js.map
